import React from 'react';
import { Avatar } from './Avatar';
import { ConversationStats } from './ConversationStats';
import { EmployeeAvatarGroup } from './EmployeeAvatarGroup';

export const ConversationCard = ({ 
  conversation, 
  isActive, 
  onClick 
}) => {
  const customerName = conversation.customerName !== 'Unknown' 
    ? conversation.customerName 
    : conversation.customerPhone;

  return (
    <div
      onClick={onClick}
      className={`p-4 border-b border-gray-100 cursor-pointer transition-all duration-200 group ${
        isActive 
          ? 'bg-purple-50/50 border-l-4 border-l-purple-600' 
          : 'hover:bg-gray-50 border-l-4 border-l-transparent'
      }`}
    >
      <div className="flex gap-3">
        <Avatar 
          name={customerName} 
          active={conversation.status === 'open'}
        />
        
        <div className="flex-1 min-w-0">
          <div className="flex justify-between items-start mb-0.5">
            <span className={`font-semibold truncate pr-2 ${isActive ? 'text-purple-900' : 'text-gray-900'}`}>
              {customerName}
            </span>
            <ConversationStats 
              lastMessageAt={conversation.lastMessageAt}
              unreadCount={conversation.unreadCount}
            />
          </div>
          
          <p className="text-sm text-gray-500 truncate mb-2">
            {conversation.lastMessage || 'No messages yet'}
          </p>

          <div className="flex justify-between items-center mt-1">
            <EmployeeAvatarGroup 
              employees={conversation.assignedTo} 
              size="xs" 
            />
          </div>
        </div>
      </div>
    </div>
  );
};
